import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { PagePaper } from "@/components/Paper/PagePaper";
import { PageTitle } from "@/components/Title";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { DesignForm } from "@/features/dmManagement/components/DesignForm";
import { useProductCategories } from "@/features/dmManagement/hooks/useProductCategories";
import { LinkButton } from "@/components/Button/LinkButton";
import { ButtonVariantOption } from "@/components/Button";
import { SizingWrapperStyle } from "@/components/Wrapper";

export const DesignFormPage: React.FC = () => {
  const { categories, isLoading } = useProductCategories();

  return (
    <PagePaper>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ContactMailIcon sx={{ mr: 1 }} fontSize="large" />
          <PageTitle>デザインデータ登録</PageTitle>
        </Box>
        <LinkButton
          variant={ButtonVariantOption.Outlined}
          href="/dmManagement/designs"
          wrapperSize={SizingWrapperStyle.INHERIT}
        >
          一覧に戻る
        </LinkButton>
      </Stack>
      {isLoading ? (
        <Typography>読み込み中...</Typography>
      ) : (
        <DesignForm categories={categories ?? []} />
      )}
    </PagePaper>
  );
};
